import {
  MODIFIER_MINIMUM,
  MODIFIER_MAXIMUM,
  NON_REQUIRED_FIELDS,
  SKIP_ONLY_TAXES,
} from 'constants/menuManagement';

export const validateMinimum = (value, values) => {
  if (value === '' || value === null) {
    return 'Minimum is required';
  }

  const numValue = Number(value);
  if (Number.isNaN(numValue)) return 'Must be a number';
  if (numValue < MODIFIER_MINIMUM) return `Minimum must be at least ${MODIFIER_MINIMUM}`;
  if (values.maximum && numValue > Number(values.maximum)) {
    return 'Minimum cannot be greater than maximum';
  }
  return null;
};

export const validateMaximum = (value, values) => {
  if (value === '' || value === null) {
    return 'Maximum is required';
  }

  const numValue = Number(value);
  if (Number.isNaN(numValue)) return 'Must be a number';
  if (numValue > MODIFIER_MAXIMUM) return `Maximum cannot exceed ${MODIFIER_MAXIMUM}`;
  if (values.minimum && numValue < Number(values.minimum)) {
    return 'Maximum cannot be less than minimum';
  }
  return null;
};

export const validateIndividualMinimum = (value, values) => {
  if (!value && value !== 0) {
    return 'Individual minimum is required';
  }
  const numValue = Number(value);
  if (Number.isNaN(numValue)) return 'Must be a number';
  if (numValue < 0) return 'Individual minimum must be at least 0';
  if (values.individualMaximum !== null && values.individualMaximum !== '' && numValue > Number(values.individualMaximum)) {
    return 'Individual minimum cannot be greater than individual maximum';
  }
  return null;
};

export const validateIndividualMaximum = (value, values) => {
  if (!value && value !== 0) {
    return 'Individual maximum is required';
  }
  const numValue = Number(value);
  if (Number.isNaN(numValue)) return 'Must be a number';
  if (values.individualMinimum !== null && values.individualMinimum !== '' && numValue < Number(values.individualMinimum)) {
    return 'Individual maximum cannot be less than individual minimum';
  }
  return null;
};

export const validatePrice = (value) => {
  if (value === null || value === '') return 'Price is required';
  return null;
};

export const validateClassifications = (value) => {
  if (!value || value.length === 0) return null;

  const alcoholicTags = value.filter(
    selected => selected.itemClass === 'alcoholic' && !selected.isDeleted,
  );
  if (alcoholicTags.length > 1) return 'Please select only one alcoholic tag.';

  const taxTypes = value.filter(
    selected => SKIP_ONLY_TAXES.includes(selected.itemClass) && !selected.isDeleted,
  );
  if (taxTypes.length > 1) return 'Please select only one tax type.';

  return null;
};

export const validateImageUrl = (value) => {
  if (!value) return null;
  const pattern = /.jpg\?|.jpeg\?|.png\?|.JPG\?|.JPEG\?|.PNG\?|.jpg$|.jpeg$|.png$|.JPG$|.JPEG$|.PNG$/;
  return pattern.test(value)
    ? null
    : 'Your image URL is not the correct file type. Please choose a .jpeg, .jpg, or .png image and try again';
};

export const validateImage = (file) => {
  // Skip validation if there's no file
  if (!file?.originFileObj) {
    return null;
  }

  const imageFile = file.originFileObj;

  // Validate file size (<5MB)
  const MAX_SIZE = 5 * 1024 * 1024;
  if (imageFile.size > MAX_SIZE) {
    return 'Image size must be less than 5MB';
  }

  // Validate file type
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
  if (!allowedTypes.includes(imageFile.type)) {
    return 'Only JPEG, JPG, and PNG files are supported';
  }

  return null;
};

export const validateInternalName = (value) => {
  if (!NON_REQUIRED_FIELDS.includes('internalName') && (!value || !value.trim())) {
    return 'Alias name is required.';
  }
  return null;
};

export const validateServingsTag = (value) => {
  if (!value) return null;

  const trimmed = String(value).trim();
  const singlePattern = /^[1-9]\d{0,2}$/;
  const rangePattern = /^([1-9]\d{0,2})-([1-9]\d{0,2})$/;

  if (singlePattern.test(trimmed)) {
    return null;
  }

  const rangeMatch = trimmed.match(rangePattern);
  if (rangeMatch) {
    const start = Number(rangeMatch[1]);
    const end = Number(rangeMatch[2]);

    if (start < end) {
      return null;
    }

    return 'For a range, the first number must be less than the second (e.g. 10-12).';
  }

  return 'Servings must be a whole number between 1 and 999, or a range like 10-12.';
};

export const normalizeServingsTag = value => {
  if (!value) return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : null;
};
